export default __webpack_public_path__ + "static/media/img-slide-5.26f55bf7.jpeg";